/**
 * Session Redux Thunks
 * Async actions for session management
 */

import { createAsyncThunk } from "@reduxjs/toolkit";
import SessionAPI from "./api";
import {
  AccountSharingResponse,
  SessionListResponse,
  LogoutSessionResponse,
} from "@/types/session";

/**
 * Fetch active sessions
 */
export const fetchActiveSessions = createAsyncThunk<
  SessionListResponse,
  void,
  { rejectValue: any }
>("session/fetchActiveSessions", async (_, { rejectWithValue }) => {
  try {
    const response = await SessionAPI.getActiveSessions();
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

/**
 * Check for account sharing
 */
export const checkAccountSharing = createAsyncThunk<
  AccountSharingResponse,
  void,
  { rejectValue: any }
>("session/checkAccountSharing", async (_, { rejectWithValue }) => {
  try {
    const response = await SessionAPI.checkAccountSharing();
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

/**
 * Logout from specific device
 */
export const logoutFromDevice = createAsyncThunk<
  LogoutSessionResponse,
  string | number,
  { rejectValue: any }
>("session/logoutFromDevice", async (sessionId, { rejectWithValue }) => {
  try {
    const response = await SessionAPI.logoutFromDevice(sessionId);
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

/**
 * Logout from all other devices
 */
export const logoutAllOtherDevices = createAsyncThunk<
  LogoutSessionResponse,
  void,
  { rejectValue: any }
>("session/logoutAllOtherDevices", async (_, { rejectWithValue }) => {
  try {
    const response = await SessionAPI.logoutAllOtherDevices();
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

/**
 * Update session activity (keep session alive)
 */
export const updateSessionActivity = createAsyncThunk<
  any,
  string | undefined,
  { rejectValue: any }
>("session/updateSessionActivity", async (sessionId, { rejectWithValue }) => {
  try {
    const response = await SessionAPI.updateSessionActivity(sessionId);
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const thunks = {
  fetchActiveSessions,
  checkAccountSharing,
  logoutFromDevice,
  logoutAllOtherDevices,
  updateSessionActivity,
};

export default thunks;
